export const STATUS_TYPES = {
  0: {
    text: '未开始',
    color: 'success'
  },
  1: {
    text: '进行中',
    color: 'warning'
  },
  2: {
    text: '已结束',
    color: 'info'
  }
};
